import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
	CardElement,
	Elements,
	useStripe,
	useElements,
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { checkdouble } from "../../constant";
import { Link } from "react-router-dom";
import { useBannersStoreMutation } from "../../store/services/BannerAdsService";
import { useProfileApiQuery } from "../../store/services/Pages/ProfileService";
import { useSelector, useDispatch } from "react-redux";
import { setSuccess, clearMessage } from "../../store/reducers/globalReducers";
import { ToastMessage } from "./../../utils/ShowToastMessage";
import "../../Assets/Css/strip.css";

const stripePromise = loadStripe(
	"pk_test_51Ln1dCFJJmnlZOnNXtsqSkIDa03oWjE5YMHEyBRHrFs3rlCgPBLH2vNZ9aHqsNFazd9fN2rPVebmWXcbDrZEFNFg00cgM98wJu",
);

const CheckoutForm = ({ Banner_Data, ImageFiles }) => {
	const [showModal, setShowModal] = useState("");
	let dispatch = useDispatch();
	let { success } = useSelector((state) => state.globalReducer);
	let { data, isFetching } = useProfileApiQuery();
	let LogingUserData = data?.response?.data;
	let [sendBannerData, response] = useBannersStoreMutation();
	const navigate = useNavigate();
	const stripe = useStripe();
	const elements = useElements();
	const [paybutton, setPayButton] = useState(true);

	useEffect(() => {
		if (Banner_Data === null) {
			navigate("/advertiseyourbanner");
		}
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (elements == null) {
			return;
		}
		const cardElement = elements.getElement(CardElement);
		const payload = await stripe.createToken(cardElement);
		// navigate("/thankyou");
		if (payload?.token?.id) {
			setPayButton(false);
			const formData = new FormData();
			formData.append("banner_image", ImageFiles);
			formData.append("start_date", Banner_Data.start_date);
			formData.append("end_date", Banner_Data.end_date);
			formData.append("description", Banner_Data.description);
			formData.append("banner_ad_slot", Banner_Data.banner_ad_slot);
			formData.append("user_id", LogingUserData.id);
			formData.append("link", Banner_Data.link);
			formData.append("stripe_token", payload.token.id);
			// formData.set("shipping_id", deliverId);
			// formData.set("stripe_token", payload.token.id);
			// formData.set("cart", JSON.stringify(mapping));
			// dispatch(SendTokenStrip(formData));
			// cardElement.clear();
			sendBannerData(formData);
			return;
		} else {
			alert("Something Went Wrong");
			// toast.error("Something Went Wrong");
			// // setTimeout(() => {
			// // 	closeForm();
			// // }, 2000);
			// cardElement.clear();
			return;
		}
	};
	useEffect(() => {
		if (response.isError) {
			ToastMessage(response?.error?.data?.message);
			setTimeout(() => {
				navigate("/advertiseyourbanner");
			}, 2000);
		}
	}, [response?.error?.status == 400]);

	useEffect(() => {
		if (response.isSuccess) {
			dispatch(setSuccess(response?.data?.message));
		}
	}, [response.isSuccess]);

	useEffect(() => {
		if (success) {
			setShowModal("fade show d-block");
		}
		return () => {
			sessionStorage.removeItem("bannerData");
			dispatch(clearMessage());
		};
	}, [success]);

	return (
		<>
			<form>
				<CardElement
					onChange={(e) => {
						if (e.complete) {
							setPayButton(false);
						} else {
							setPayButton(true);
						}
					}}
				/>
				<br />

				<ul className="list-inline button-group">
					<li className="button-group">
						<button
							type="submit"
							className="btn "
							disabled={!stripe || !elements || paybutton}
							// data-bs-toggle="modal"
							// href="#exampleModalToggle"
							onClick={handleSubmit}
						>
							{response?.isLoading ? "Loading..." : "Pay Now"}
						</button>
					</li>
				</ul>
			</form>
			<div className="col-md-12">
				<div className="adbannerdetail"></div>
				<div className="button-group">
					<div
						className={`modal fade ${showModal}`}
						id="exampleModalToggle"
						aria-hidden="true"
						aria-labelledby="exampleModalToggleLabel"
						tabindex="-1"
					>
						<div className="modal-dialog modal-dialog-centered">
							<div className="modal-content">
								<div className="modal-body">
									<img src={checkdouble} className="img-fluid"></img>
									<h4>Your Subscription Payment Was Successful Paid</h4>
									<p>your subscription payment has been successful done</p>
									<Link to="/bannerads" className="btn">
										Go To BannerAds Page
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const StripeForm = ({ Banner_Data, ImageFiles }) => {
	return (
		<Elements stripe={stripePromise}>
			<CheckoutForm Banner_Data={Banner_Data} ImageFiles={ImageFiles} />
		</Elements>
	);
};

export default StripeForm;
